import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useCart } from "../../components/Client/context/CartContext"; // Importar el contexto del carrito
import "./ProductDetail.css";

const ProductDetail = () => {
  const { id } = useParams(); // Obtener el ID del producto desde la URL
  const [product, setProduct] = useState(null);
  const { addToCart } = useCart(); // Obtener la función para añadir al carrito desde el contexto

  useEffect(() => {
    // Aquí puedes reemplazar este código con una llamada a tu backend para obtener los datos del producto
    const fetchProduct = async () => {
      const mockProducts = [
        { id: "1", name: "Producto 1", description: "Descripción detallada del Producto 1", price: "100.00", image: "/product1.png" },
        { id: "2", name: "Producto 2", description: "Descripción detallada del Producto 2", price: "200.00", image: "/product2.png" },
        { id: "3", name: "Producto 3", description: "Descripción detallada del Producto 3", price: "300.00", image: "/product3.png" },
      ];
      const productFound = mockProducts.find((prod) => prod.id === id);
      setProduct(productFound);
    };

    fetchProduct();
  }, [id]);

  if (!product) {
    return <div className="product-detail-loading">Cargando producto...</div>;
  }

  return (
    <div className="product-detail-container">
      <div className="product-detail-image">
        <img src={product.image} alt={product.name} />
      </div>
      <div className="product-detail-info">
        <h2 className="product-detail-name">{product.name}</h2>
        <p className="product-detail-description">{product.description}</p>
        <p className="product-detail-price">Precio: ${product.price}</p>
        <button
          className="add-to-cart-btn"
          onClick={() => addToCart(product)} // Añadir el producto al carrito
        >
          Añadir al carrito
        </button>
      </div>
    </div>
  );
};

export default ProductDetail;
